import React from "react";


// Styles
import styles from "./progress.module.scss";

// Types
interface ProgressProps {
  progress: number;
  classes?: {
    progressContainer?: string;
    progressBar?: string;
  };
}

const Progress: React.FC<ProgressProps> = ({ progress, classes }) => {
  let progressContainerClass = styles.progressContainer;
  let progressBarClass = styles.progressBar;

  if (classes) {
    if (classes.progressContainer) {
      progressContainerClass += ` ${classes.progressContainer}`;
    }
    if (classes.progressBar) {
      progressBarClass += ` ${classes.progressBar}`;
    }
  }

  return (
    <div className={progressContainerClass}>
      <div
        className={progressBarClass}
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export default Progress;
